<div class="p-3 rounded-3">
  <div class="row">
    <div class="col-12 mb-3">
      <div class="titletoptables">
        <div class="leftsideicons">
          <img src="../../assets/image/error-log.png" alt="error-log" onkeydown="" />
        </div>
        <h3>{{ "Login Logs" }}</h3>
      </div>
    </div>
    <div class="row position">
      <div class="col-lg-12 kt-margin-bottom-20-mobile">
        <div class="col-md-2 mb-3">
          <div class="srchgrid texttarget">
            <input class="searchtextbox" matInput (keyup)="filterData($any($event.target).value)" [value]="searchString"
              placeholder="Search" autocomplete="off">
            <div class="closeicon" (keydown.enter)="clearList()" (click)="clearList()"> <span
                aria-hidden="true">&times;</span> </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <mat-form-field class="w-100 custom-blue">
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate" />
              <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
              <mat-datepicker #pickerStart></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="w-100 custom-blue">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="endDate" />
              <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
              <mat-datepicker #pickerEnd></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-1 mt-2">
            <button type="button" class="btn btn-primary" (click)="loadData()">Apply</button>
          </div>
          <div class="col-md-7 Counts mb-3">
            <div class="toogle">
              <label for="DestopCount"><b>Total Desktop User : </b>{{DestopCount}}</label>
              <label style="margin-left: 20px" for="MobileCont"><b>Total Mobile User : </b>{{MobileCont}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="position">
    <kendo-grid #grid  [loading]='kendoLoading' [data]="gridData" [filter]="state.filter" [sortable]="{mode: 'single'}"
      [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
      [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false" [sort]="sort"
      (sortChange)="gridData ? sortChange($event): null" [resizable]="true" [reorderable]="true" filterable="menu"
      [filter]="state.filter" [selectable]="true" (dataStateChange)="gridData ? dataStateChange($event): null"
      (columnVisibilityChange)="onColumnVisibilityChange(grid)"
      [navigable]="true" [height]="gridHeight">
      <kendo-grid-column field="CompanyId" title="CompanyId" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="Username" title="Username" [width]='30'>
      </kendo-grid-column>
      <kendo-grid-column field="IpAddress" title="IpAddress" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="Location" title="Location" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="DeviceType" title="DeviceType" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="LoginTime" title="LoginTime" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="Domain" title="Domain" [width]='20'>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>